// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/update/v1/app.proto (package msh.trait.update.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message msh.trait.update.v1.AppTrait
 */
export const AppTrait = proto3.makeMessageType(
  "msh.trait.update.v1.AppTrait",
  [],
);

/**
 * ----------- Commands ----------- //
 *
 * @generated from message msh.trait.update.v1.AppTrait.Command
 */
export const AppTrait_Command = proto3.makeMessageType(
  "msh.trait.update.v1.AppTrait.Command",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version_code", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
  {localName: "AppTrait_Command"},
);

/**
 * ----------- EVENTS ----------- //
 *
 * @generated from message msh.trait.update.v1.AppTrait.RequestEvent
 */
export const AppTrait_RequestEvent = proto3.makeMessageType(
  "msh.trait.update.v1.AppTrait.RequestEvent",
  () => [
    { no: 1, name: "model_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version_code", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
  {localName: "AppTrait_RequestEvent"},
);

/**
 * @generated from message msh.trait.update.v1.AppTrait.UpdateFailEvent
 */
export const AppTrait_UpdateFailEvent = proto3.makeMessageType(
  "msh.trait.update.v1.AppTrait.UpdateFailEvent",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "retry", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "current_version", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "requested_version", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
  {localName: "AppTrait_UpdateFailEvent"},
);

